import fn from "@/mixins/helpers"
import CertificateList from "./components/List"

let module = "certificates"
let CertificateForm = null
let isMobile = fn.methods.$isMobile()

if (!isMobile) {
  CertificateForm = () => import("./components/Form")
} else {
  CertificateForm = () => import("./components/mobile/Form")
}

export default [
  { path: "certificates", component: CertificateList, meta: { module: module, permissions: ["certificate-access"] } },
  {
    path: "certificates/create",
    component: CertificateForm,
    props: true,
    meta: { module: module, permissions: ["certificate-create"] }
  },
  {
    path: "certificates/edit/:id",
    component: CertificateForm,
    props: true,
    meta: { module: module, permissions: ["certificate-edit"] }
  }
]
